require('./bootstrap')
window.Vue2 = require('vue/dist/vue.common.js')

require('./raven')
require('./components')
require('./plugins')
require('./filters')

import store from './vuex/index'
import Sticky from 'sticky-js'

const app = new Vue2({
  store,
  el: '#app',
  data() {
    return {
      sidebar: true,
      memberIndexView: 'card',
      overlay: false,
      UserAbilities: window.UserAbilities,
      isSuperAdmin: window.isSuperAdmin,
      Union: window.Union,
      baseSupportUrl: window.baseSupportUrl,
      commDateFormat: window.momentDateFormat,
      hasAcceptedTerms: window.HasAcceptedTerms,
      showBlockingMembershipFeeModal: window.showBlockingMembershipFeeModal,
      isMissingProfileInformation: window.isMissingProfileInformation,
      profileSharingIsEnabled: window.profileSharingIsEnabled,
      profileUrl: window.profileUrl,
    }
  },
  computed: {
    unreadNotificationCount() {
      return store.getters.notificationUnreadNotificationCount
    },
    pendingDocumentShareCount() {
      return store.getters.documentGetPendingDocumentShareCount
    },
    pendingFolderShareCount() {
      return store.getters.documentGetPendingFolderShareCount
    },
    pendingShareCount() {
      return this.pendingDocumentShareCount + this.pendingFolderShareCount
    },
    openedModalId() {
      return store.getters.openedModalId
    },
    openedModalPayload() {
      return store.getters.openedModalPayload
    },
    openedModal() {
      return store.getters.openedModal
    },
  },
  mounted() {
    store.commit('userSetAbilities', this.UserAbilities)
    this.$nextTick(function () {
      new Sticky('sidebar')

      let sidebarStatus = localStorage.getItem('sidebar.state')

      if (window.matchMedia('(max-width: 768px)').matches) {
        this.sidebar = false
      } else if (sidebarStatus) {
        this.sidebar = JSON.parse(sidebarStatus)
      } else {
        localStorage.setItem('sidebar.state', JSON.stringify(true))
      }

      let memberIndexView = localStorage.getItem('memberIndexView')

      if (memberIndexView) {
        this.setMemberIndexView(memberIndexView)
      } else {
        localStorage.setItem('memberIndexView', 'card')
      }

      if (window.fetchNotifications) {
        store.dispatch('notificationGetUnreadCount')

        if (this.userCan('edit-documents')) {
          store.dispatch('documentGetPendingShareCounts')
        }
      }
    })
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar
      localStorage.setItem('sidebar.state', JSON.stringify(this.sidebar))

      let element = document.getElementsByTagName('body')[0]
      if (this.sidebar && window.innerWidth < 768) {
        element.classList.add('overflow-hidden')
      } else {
        element.classList.remove('overflow-hidden')
      }
    },

    setMemberIndexView(view) {
      this.memberIndexView = view
      localStorage.setItem('memberIndexView', view)
    },
    // Use the v-can acl directive instead.
    userCan(ability) {
      return store.getters.hasAbility(ability)
    },
    openModalWithPayload(modalId, payload) {
      store.dispatch('setModalPayload', payload)
        .then(() => {
          store.dispatch('showModal', modalId)
        })
    },
    openModal(modalId) {
      store.dispatch('showModal', modalId)
    },
    closeModal() {
      return store.dispatch('closeModal')
    },

    membersMobileNavigation(e){
      if(e.target.value == 'card' || e.target.value == 'list') {
        this.setMemberIndexView(e.target.value)
      } else {
        window.location = e.target.value
      }
    },

    documentsMobileNavigation(e){
      window.location = e.target.value
    },
  },
})
